export const CORRELATION_HEADER = 'x-correlation-id'
